import React, { useState, useEffect } from 'react';
import { string, oneOf, func } from 'prop-types';
import { PRODUCT_ADD_ON_IDENTIFIER } from '@thd-olt-functional/utils';
import { Secure } from '@one-thd/sui-icons';
import { ProductAddOnsPodStencil } from '../../common/product-add-ons-pod/ProductAddOnsPodStencil';
import { ProtectionPlanDrawer } from './ProtectionPlanDrawer';

const { HDPP } = PRODUCT_ADD_ON_IDENTIFIER;

export const HomeDepotProtectionPlan = ({
  itemId,
  channel,
  term,
  price,
  onChange,
}) => {

  const [isHdppSelected, setIsHdppSelected] = useState(false);
  const [isDualPathSelected, setIsDualPathSelected] = useState(null);

  const subHeading = 'Select a Home Depot Protection Plan by Allstate for:';
  /** Props for checkbox component */
  const userOptions = [{
    id: itemId,
    value: 'hdpp-accept',
    label: `${term} Year / `,
    price,
    checked: isHdppSelected,
  },
  {
    value: 'hdpp-decline',
    label: 'No thanks',
    checked: !isHdppSelected
  }];

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.on('dual-path.change', ({ output } = {}) => {
      setIsDualPathSelected(output?.isOptedIn);
    });
  }, []);

  const handleChange = (evt) => {
    const userSelectedHdpp = evt.target.value === 'hdpp-accept';
    let checked = userSelectedHdpp && !isHdppSelected;
    onChange({
      itemId,
      checked,
      addOnType: HDPP
    });
    LIFE_CYCLE_EVENT_BUS.trigger('hdpp.change', { isOptedIn: checked, itemId });
    setIsHdppSelected(checked);

  };

  const drawer = (
    <ProtectionPlanDrawer channel={channel} />
  );

  if (isDualPathSelected) {
    return null;
  }

  return (
    <ProductAddOnsPodStencil
      heading="Protect This Item"
      subHeading={subHeading}
      tooltip={drawer}
      icon={<Secure size="large" color="primary" />}
      userOptions={userOptions}
      onChange={handleChange}
      channel={channel}
      radio
    />
  );
};

HomeDepotProtectionPlan.displayName = 'ProductAddOns-HomeDepotProtectionPlan';

HomeDepotProtectionPlan.propTypes = {
  /** Device Type: Mobile or Desktop */
  channel: oneOf(['desktop', 'mobile']),
  /** protection plan price */
  price: string.isRequired,
  /** protection plan term length */
  term: string,
  /** handler for select or unselect hdpp */
  onChange: func.isRequired,
  /** protection plan item id */
  itemId: string.isRequired,
};

HomeDepotProtectionPlan.defaultProps = {
  channel: 'desktop',
  term: '',
};